import { render, staticRenderFns } from "./HrTrainCertProfession.vue?vue&type=template&id=24e36850&scoped=true&"
import script from "./HrTrainCertProfession.vue?vue&type=script&lang=js&"
export * from "./HrTrainCertProfession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e36850",
  null
  
)

export default component.exports